var isValid = function isValid(value) {
  return value !== undefined && value !== null && value !== '';
};
export default isValid;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/_util/isValid.js
// module id = null
// module chunks = 